import React from 'react';
import { Instagram } from 'components/Icons/Social';

export default props => {
    return  <a href={'https://www.instagram.com/zippertic/'} title='Instagram' {...props}><Instagram /></a>;
}